export default __webpack_public_path__ + "static/media/svg-1.117e59e2.svg";